const DataKehadiran = [
  { 
    id: "0",
    tanggal: "7/08/2020",
    namaMateri: "Palang Merah Indonesia",
    statusKehadiran: "Tidak Hadir",
  },
  { 
    id: "1",
    tanggal: "14/08/2020",
    namaMateri: "Pertolongan Pertama",
    statusKehadiran: "Tidak Hadir"
  },
  {
    id: "2",
    tanggal: "21/08/2020",
    namaMateri: "Tanggap Bencana",
    statusKehadiran: "Tidak Hadir"
  },
  {
    id: "3",
    tanggal: "28/08/2020",
    namaMateri: "Forum Relawan",
    statusKehadiran: "Tidak Hadir"
  },
  {
    id: "4",
    tanggal: "7/08/2020",
    namaMateri: "Donor Darah",
    statusKehadiran: "Tidak Hadir"
  },
];

export default DataKehadiran